<script>
export default {}
</script>
<template>
  <icon-base name="cheveron-left">
    <path d="M7.05 9.293L6.343 10 12 15.657l1.414-1.414L9.172 10l4.242-4.243L12 4.343z" />
  </icon-base>
</template>   